export class Language {
  constructor(
    public key: string,
    public description: string,
    public icon: string,
    public active: boolean,
    public id?: string | number
  ) { }
}
